'use client';

import { type OneLine } from 'pxr-oneline';

declare global {
    interface Window {
        ndmOneStub?: {
            que: Array<() => void>;
        };
    }
}

declare const ndmOne: OneLine | undefined;

export const setBettingCookie = (value: boolean) => {
    if (Array.isArray(window.ndmOneStub?.que)) {
        window.ndmOneStub.que.push(() => {
            if (ndmOne) {
                ndmOne.setBettingCookie(value);
            }
        });
    }
};
